import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
const messages = {
  en: {
    hello: "Hello",
    MethodOfPayment: "Method of Payment",
    Currency: "Currency",
    Language: "Language",
    Search: "Search",
    SignIn: "Sign In",
    SignOut: "Sign Out",
    Favorite: "Favorite",
    Profile: "Profile",
    MyProfile: "Profile",
    MyCart: "My Cart",
    NotCart: "There are no items in this cart",
    Cart: "Cart",
    Categories: "Categories",
    CartAmount: "{num} item",
    Summary: "Summary",
    ShippingCharge: "Shipping Fee",
    ShippingServices: "Shipping Services",
    Subtotal: "Subtotal",
    Next: "Next",
    Policy: "Policy",
    ContactUs: "Contact Us",
    SoldOut: "Sold Out",
    Register: "Register",
    ResetPass: "Reset Password?",
    OR: "OR",
    NewCustomer: "New Customer",
    inPasswordConfirm: "Password confirm",
    Send: "Send",
    MessageReset:
      "If the user forgets the password The system will send a new password to Members via email that you have subscribed to",
    TextRegister:
      "Register with us You will be able to manage payments faster, collect multiple shipping addresses. Along with watching and following Your order",
    AddCart: "Add to Cart",
    Amount: "Quantity",
    Total: "Total",
    ByNow: "Buy Now",
    TotalAmount: "There are {quantity} items",
    DetailProduct: "Product Detail",
    Address: "Address",
    ShippingAddress: "Shipping address",
    AddAddress: "Add New Address",
    UpdateAddress: "Update Address",
    Street: "Street",
    Province: "Province",
    SelectProvince: "Select Province",
    District: "District",
    SelectDistrict: "Select District",
    Amphur: "Amphur",
    SelectAmphur: "Select Amphur",
    PostCode: "Post Code",
    ConfirmPassword: "Confirm Password",
    Password: "Password",
    NewPassword: "New Password",

    //favorite
    MyFavorite: "My Favorite",
    NotFavorite: "You do not have a list of products in the list",
    NowShop: "CONTINUE SHOPPING",

    //product
    FindItem: "Find Items",
    View: "View",
    PriceLH: "Low - high",
    PriceHL: "high - Low",
    Price: "Price",

    //validate
    rqEmail: "Please enter an email.",
    rqEmailUnique: "The email has already been taken.",
    rqPass: "Please enter an password.",
    rqPassMin: "รหัสผ่านอย่างน้อย {num} ตัว",

    //input
    inEmail: "Email",
    inPassword: "Password",

    //profile
    Menu: "Menu",
    Account: "Account",
    ChangePassword: "Change Password",
    HistoryOrders: "History Orders",
    Name: "Name",
    Birthday: "Birthday",
    Sex: "Sex",
    Mobile: "Mobile",
    Email: "Email",
    Update: "Update",
    Delete: "Delete",
    Save: "Save",
    Cancel: "Cancel",

    //cart
    ChooseShippingAddress: "Choose a shipping address",
    OrderList: "Order list",
    OrderSuccessful: "Order successful",
    Payment: "Payment",
    ChoosePaymentMethod: "Choose payment method",
    CreditDebitCard: "Credit / debit card",
    MoneyTransfer: "Money Transfer",
    UploadTransferSlip: "Upload transfer slip",
    Upload: "Upload",
    OrderNo: "Order No",
    DeliveryType: "Delivery Option",
    atStore: "at Shop",
    carrier: "Carrier",

    //History Orders
    OrderOn: "Order on",
    Pending: "Pending",
    ReadyToShip: "Ready",
    ShippingNow: "Shipping",
    Finish: "Finish",
    Items: "Items",

    //alert
    ShoppingCart: "Shopping cart",
    OutStock: "out stock",
    OrderingProduct: "ordering product",
    sale: "sale",
    forgotSuccess: "The password has been sent to the email.",

    ContactUs: "Contact Us"
  },
  th: {
    hello: "สวัสดี",
    MethodOfPayment: "วิธีการชำระเงิน",
    Currency: "สกุลเงิน",
    Language: "ภาษา",
    Search: "ค้นหา",
    SignIn: "ลงชื่อเข้าใช้",
    SignOut: "ออกจากระบบ",
    Favorite: "ถูกใจ",
    Profile: "ส่วนตัว",
    MyProfile: "ข้อมูลส่วนตัว",
    Cart: "ตะกร้า",
    MyCart: "ตะกร้าสินค้า",
    NotCart: "คุณไม่มีรายการสินค้าในตะกร้าสินค้า",
    Summary: "สรุปยอดการสั่งซื้อ",
    ShippingCharge: "ค่าจัดส่ง",
    Subtotal: "มูลค่าสินค้า",
    Next: "ดำเนินการต่อ",
    CartAmount: "มี {num} รายการ",
    Categories: "หมวดหมู่สินค้า",
    Policy: "นโยบายการใช้งาน",
    ContactUs: "ติดต่อเรา",
    SoldOut: "สินค้าหมด",
    Register: "สมัครสมาชิก",
    ResetPass: "ลืมรหัสผ่าน?",
    OR: "หรือ",
    NewCustomer: "ลูกค้าใหม่",
    inPasswordConfirm: "ยืนยันรหัสผ่าน",
    Send: "ส่งข้อมูล",
    MessageReset:
      "กรณีที่ผู้ใช้ลืมรหัสผ่าน ระบบจะส่งรหัสผ่านใหม่ไปให้ สมาชิกผ่านทาง อีเมล ที่ท่านสมัครไว้",
    TextRegister:
      "สมัครสมาชิกกับเรา คุณจะสามารถจัดการชำระเงินได้เร็วขึ้น, เก็บที่อยู่ในการจัดส่งได้หลายรายการ พร้อมทั้งดูและติดตาม คำสั่งซื้อของคุณได้",
    AddCart: "ใส่ตะกร้า",
    Amount: "จำนวน",
    Total: "ราคารวม",
    ByNow: "ซื้อเลย",
    TotalAmount: "มีสินค้า {quantity} ชิ้น",
    DetailProduct: "รายละเอียดสินค้า",
    Address: "ที่อยู่",
    ShippingAddress: "ที่อยู่ในการจัดส่ง",
    ShippingServices: "บริการจัดส่งสินค้า",
    AddAddress: "เพิ่มที่อยู่ในการจัดส่ง",
    UpdateAddress: "แก้ไขอยู่ในการจัดส่ง",
    Street: "ถนน",
    Province: "จังหวัด",
    SelectProvince: "เลือกจังหวัด",
    District: "แขวง/ตำบล",
    SelectDistrict: "เลือกแขวง/ตำบล",
    Amphur: "เขต/อำเภอ",
    SelectAmphur: "เลือกเขต/อำเภอ",
    PostCode: "รหัสไปรษณีย์",
    ConfirmPassword: "ยืนยันรหัสผ่าน",
    Password: "รหัสผ่าน",
    NewPassword: "รหัสผ่านใหม่",

    //favorite
    MyFavorite: "สินค้าที่ถูกใจ",
    NotFavorite: "คุณไม่มีรายการสินค้าในรายการที่ถูกใจ",
    NowShop: "ไปช้อปกันเถอะ",

    //product
    FindItem: "พบสินค้า",
    View: "แสดงผล",
    PriceLH: "ราคาต่ำสุด - ราคาสูงสุด",
    PriceHL: "ราคาสูงสุด - ราคาต่ำสุด",
    Price: "ราคา",

    //validate
    rqEmail: "กรุณากรอกอีเมล",
    rqEmailUnique: "มีผู้ใช้งานนี้อีเมลแล้ว",
    rqPass: "กรุณากรอกรหัสผ่าน",
    rqPassMin: "รหัสผ่านอย่างน้อย {num} ตัว",

    //input
    inEmail: "อีเมล",
    inPassword: "รหัสผ่าน",

    //profile
    Menu: "เมนู",
    Account: "ข้อมูลส่วนตัว",
    ChangePassword: "แก้ไขรหัสผ่าน",
    HistoryOrders: "รายการสั่งซื้อ",
    Name: "ชื่อ-นามสกุล",
    Birthday: "วันเกิด",
    Sex: "เพศ",
    Mobile: "เบอร์โทรศัพท์",
    Email: "อีเมล",
    Update: "แก้ไข",
    Delete: "ลบ",
    Save: "บันทึก",
    Cancel: "ยกเลิก",

    //cart
    ChooseShippingAddress: "เลือกที่อยู่จัดส่งสินค้า",
    OrderList: "รายการสั่งซื้อ",
    OrderSuccessful: "การสั่งซื้อเสร็จสิ้น",
    Payment: "ชำระเงิน",
    ChoosePaymentMethod: "เลือกวิธีชำระเงิน",
    CreditDebitCard: "บัตรเครดิต / เดบิต",
    MoneyTransfer: "แจ้งโอนเงิน",
    UploadTransferSlip: "อัพโหลดสลิปหลักฐานการโอน",
    Upload: "อัพโหลด",
    OrderNo: "เลขที่ใบสั่งซื้อ",
    DeliveryType: "ช่องทางการจัดส่ง",
    atStore: "รับที่ร้าน",
    carrier: "บริการขนส่ง",

    //History Orders
    OrderOn: "สั่งซื้อเมื่อวันที่",
    Pending: "รอดำเนินการ",
    ReadyToShip: "พร้อมจัดส่ง",
    ShippingNow: "กำลังจัดส่ง",
    Finish: "เสร็จสิ้น",
    Items: "ชิ้น",

    //alert
    ShoppingCart: "ตะกร้าสินค้า",
    OutStock: "สินค้าหมด",
    OrderingProduct: "สั่งซื้อสินค้า",
    sale: "ลด",
    forgotSuccess: "รหัสผ่านถูกส่งไปยังอีเมลเรียบร้อยแล้ว",

    ContactUs: "ติดต่อเรา"
  }
};
const i18n = new VueI18n({
  locale: "th", // set locale
  fallbackLocale: "en", // set fallback locale
  messages // set locale messages
});
export default i18n;
